import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
// import TodoListDesktop from "../../Assets/Projects/TodoListDesktop.png";
// import NextProj from "../../Assets/Projects/Next6ProjectLoadinbgmonitor.png";
// import LibAppDesktop from "../../Assets/Projects/LibAppDesktop.png";
// import ICTDesktop from "../../Assets/Projects/ICTDesktop.png";
// import TravelDesktop from "../../Assets/Projects/TravelDesktop.png";
// import playTVDesktop from "../../Assets/Projects/playTVDesktop.png";

function Projects() {
    let TodoListDesktop = "https://res.cloudinary.com/dj6eghdzu/image/upload/v1682971114/PortfolioWebsite/TodoListDesktop_sjb8xg.png";
    let NextProj = "https://res.cloudinary.com/dj6eghdzu/image/upload/v1682971108/PortfolioWebsite/Next6ProjectLoadinbgmonitor_ubg014.png";
    let LibAppDesktop = "https://res.cloudinary.com/dj6eghdzu/image/upload/v1682971114/PortfolioWebsite/LibAppDesktop_hlkjg4.png";
    let ICTDesktop = "https://res.cloudinary.com/dj6eghdzu/image/upload/v1682971112/PortfolioWebsite/ICTDesktop_t5kw5t.png";
    let TravelDesktop = "https://res.cloudinary.com/dj6eghdzu/image/upload/v1682971113/PortfolioWebsite/TravelDesktop_enmbqk.png";
    let playTVDesktop = "https://res.cloudinary.com/dj6eghdzu/image/upload/v1682971110/PortfolioWebsite/playTVDesktop_hfmtfe.png"; 
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent <strong className="purple">projects </strong>
        </h1>
        <p style={{ color: "white" }}>
        These are some projects I have recently been Worked.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ICTDesktop}
              isBlog={true}
              title="ICT Academy of Kerala"
              description="The ICT Academy of Kerala is an organization that is dedicated to providing high-quality education and training to the youth of Kerala in various sectors related to Information and Communication Technology (ICT). The academy aims to enhance the employability of young people and promote the growth of the IT industry in the state."
              ghLink="https://github.com/akhiljptvm/ICT-Official-Website_MEAN-Live"
              demoLink="ictacademyofficial.herokuapp.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={playTVDesktop}
              isBlog={true}
              title="PLAY TV(MediaStream app)"
              description="PlayTV MediaStream is a web-based application that allows users to stream live television channels and on-demand video content directly from their web browser.With PlayTV MediaStream, users can watch entertainment videos. The admin panel allows the app owner or administrator to manage and control the app's content and user management system"
              ghLink="https://github.com/akhiljptvm/TCS-iON-Intern-MediaStream"
              demoLink="MediaStream.herokuapp.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={LibAppDesktop}
              isBlog={true}
              title="Library App"
              description="A library web app is a web-based application that is designed to manage and facilitate the operations of a library. It serves as a central hub for library patrons to search for and access library resources, as well as for librarians to manage and organize those resources.Library patrons can search for books, journals, articles, and other resources by title, author, keyword, or subject."
              ghLink="https://github.com/akhiljptvm/LibraryApp_mean"
              demoLink="librarymean-app.herokuapp.com/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TodoListDesktop}
              isBlog={true}
              title="TODO LIST - AI"
              description="A todo list web app is a web-based application designed to help users manage and organize their tasks, projects, and deadlines. The app provides an intuitive interface for users to create, edit, and prioritize their to-do lists.Users can create new tasks and assign them to different categories or lists, such as work, personal, or school."
              ghLink="https://github.com/akhiljptvm/SimpleToDoList"
              demoLink="https://akhilakku008.github.io/SimpleToDoList/login"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TravelDesktop}
              isBlog={true}
              title="Travel Friend - connect travelers"
              description="A travel friend web app is a web-based application designed to connect travelers with other travelers who share similar interests and travel plans. The app helps users find new friends and travel companions for their trips, making their travel experience more enjoyable and memorable., a travel friend web app is a valuable tool for travelers who want to connect with like-minded individuals and make their travel experience more enjoyable and fulfilling."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={NextProj}
              isBlog={true}
              title="Impressive projects currently in development."
              description="Some amazing web projects are under development. Keeping an eye on these upcoming projects can help developers stay up to date with the latest trends and technologies, and help them build better and more advanced web applications.we can expect to see more innovative and engaging web experiences being created for users around the world.."
      
             
            />
          </Col>
        </Row>
      </Container>
      {/* <section class="call-buton"><a class="cc-calto-action-ripple" href="tel:918921093869"><i class="fa fa-phone"></i><span class="num"></span>
      </a>
      </section> */}
    </Container>
  );
}

export default Projects;
